import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { AdminChats } from './AdminChats';
import { AdminDebtCollection } from './AdminDebtCollection';
import { AdminDocuments } from './AdminDocuments';
import { AdminSnippets } from './AdminSnippets';
import { AdminTickets } from './AdminTickets';

import { TabPanel } from '@components/ui/TabPanel/TabPanel';
import { User } from '@dieterApi/user/useUserQuery';
import { useTranslation } from 'react-i18next';
import './route-admin.sass';

interface Props {
  user?: User | null;
}

export default function Admin({ user }: Props) {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState('Documents');
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <div className="2xl:container p-6">
      <h3 className="text-xl font-medium">{t('route.admin.title', 'Administration')}</h3>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs onChange={handleChange} aria-label="lab API tabs example" value={tabValue}>
          <Tab label={t('route.admin.documents-tap-label', 'Dokumente')} value="Documents" />
          <Tab label={t('route.admin.chats-tab-label', 'Chats')} value="Chats" />
          <Tab label={t('route.admin.snippets-tab-label', 'Snippets')} value="Snippets" />
          <Tab label={t('route.admin.tickets-tab-label', 'Tickets')} value="Tickets" />
          <Tab label={t('route.admin.debt-collection-tab-label', 'Inkasso')} value="DebtCollection" />
        </Tabs>
      </Box>
      <TabPanel index="Documents" value={tabValue}>
        <AdminDocuments user={user} />
      </TabPanel>
      <TabPanel index="Chats" value={tabValue}>
        <AdminChats user={user} />
      </TabPanel>
      <TabPanel index="Snippets" value={tabValue}>
        <AdminSnippets />
      </TabPanel>
      <TabPanel index="Tickets" value={tabValue}>
        <AdminTickets />
      </TabPanel>
      <TabPanel index="DebtCollection" value={tabValue}>
        <AdminDebtCollection />
      </TabPanel>
    </div>
  );
}
